export default __webpack_public_path__ + "static/media/doc.db52e0d1.svg";